


























































































































import {
  SPACES_POSITIONS,
  SPACES_VALUES,
} from "@/resources/constants/graphicClient/roomsPositions";
import { GREEN, RED } from "@/resources/constants/busyReasons";
import { RoomInterface } from "@/resources/interfaces/roomInterfaces";
import { ROOM_TYPE } from "@/resources/constants/space";
import { Component, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { i18n } from "@/resources/locales";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import Loader from "@/resources/mixins/loader/loader";
@Component({
  name: "space-component",
})
export default class SpaceComponent extends mixins(NotificationEvent, Loader) {
  @Prop() index: string;
  @Prop() space;
  roomSelected: RoomInterface | null = null;
  roomSelectedId: number;
  showRooms = false;
  city = false;
  busy = "";
  isLoadImage = true;
  async mounted(): Promise<void> {
    this.city = localStorage.getItem("city") == "ON" ? true : false;
    this.getBusy();
  }

  isOpenSpace(): boolean {
    const user = this.$store.getters["UserStore/getUser"];
    const spaceUser = this.$store.getters["UserStore/getSpaceUser"];

    if (!this.space.enabledBySuperAdmin) return false;
    if (this.space.spaceUser && this.space.spaceUser?.deletedAt) return false;
    if (
      this.space.enabled &&
      this.space.enabledBySuperAdmin &&
      (!this.space.spaceUser ||
        (this.space.spaceUser && this.space.spaceUser.enabled))
    )
      return true;

    if (
      this.space.createdBy.id ===
        (this.city
          ? user.id
          : spaceUser
          ? spaceUser.superSpaceUser.user.id
          : 0) ||
      (this.space.spaceUser && this.space.spaceUser.isAdmin)
    )
      return true;
    if (this.space.isSuperSpaceUserAdmin) return true;
    if (!this.space.isSuperSpaceUserEnabled) return false;
    return false;
  }
  closeSpaceCase(): number {
    if (this.space.spaceUser && this.space.spaceUser?.deletedAt) return 3;
    if (
      !this.space.spaceUser?.isAdmin &&
      !this.space.isSuperSpaceUserAdmin &&
      !this.space.enabled
    )
      return 1;
    if (!this.space.enabledBySuperAdmin) return 2;
    if (
      (this.space.spaceUser && !this.space.spaceUser.enabled) ||
      (this.space.isSuperSpaceUserEnabled !== null &&
        this.space.isSuperSpaceUserEnabled === false)
    )
      return 4;
    return 0;
  }
  closeSpaceCaseText() {
    switch (this.closeSpaceCase()) {
      case 1:
      case 2:
        return i18n.t("tooltips.disableSpace");
      case 3:
        return i18n.t("tooltips.deleteUser");
      case 4:
        return i18n.t("tooltips.disableUser");
      default:
        return "";
    }
  }
  getBusy(): string {
    if (
      this.space.usersConnected == 0 ||
      this.space.usersConnected <= this.space.usersConnectedLimit / 2
    ) {
      this.busy = i18n.t("labels.free").toString();
      return GREEN.color;
    }
    if (
      this.space.usersConnected != 0 &&
      this.space.usersConnected >= this.space.usersConnectedLimit
    ) {
      this.busy = i18n.t("labels.full").toString();
      return RED.color;
    }
    if (
      this.space.usersConnected != 0 &&
      this.space.usersConnected > this.space.usersConnectedLimit / 2
    ) {
      this.busy = i18n.t("labels.almostFull").toString();
      return "orange";
    }
    return GREEN.color;
  }
  showRoomsModal() {
    this.showRooms = true;
    setTimeout(async () => {
      await this.loadImage();
    }, 300);
  }
  async loadImage(): Promise<any> {
    const image = document.getElementById("image-space");
    this.isLoadImage = true;
    if (image instanceof HTMLImageElement) {
      return new Promise((resolve, reject) => {
        image.onload = () => {
          resolve(image);
          this.setPositions(
            SPACES_POSITIONS[this.space.scenario.scenarioType.name],
            SPACES_VALUES[this.space.scenario.scenarioType.name]
          );
        };

        this.isLoadImage = false;
        image.onerror = reject;
        image.src = this.space.scenario.scenarioType.topViewImage ? this.space.scenario.scenarioType.topViewImage.url : null;
      });
    }
  }
  setPositions(roomsPositions, spaceValuesPosition): void {
    let imageDiv = document.getElementById("selector-image");
    if (imageDiv) {
      const width = imageDiv.offsetWidth;
      const heigth = imageDiv.offsetHeight;
      for (const position in roomsPositions) {
        if (
          roomsPositions[position].type === ROOM_TYPE.WEBINAR ||
          roomsPositions[position].type === ROOM_TYPE.MEETING ||
          roomsPositions[position].type === ROOM_TYPE.SPEED_NETWORKING
        ) {
          const x =
            this.invLerp(
              spaceValuesPosition[0],
              spaceValuesPosition[2],
              roomsPositions[position].position.x
            ) * width;
          const y =
            this.invLerp(
              spaceValuesPosition[1],
              spaceValuesPosition[3],
              -roomsPositions[position].position.z
            ) * heigth;
          const item = document.createElement("div");
          item.setAttribute("class", "roomId");
          const searchItemRoom = document.getElementById("room-" + position);
          if (searchItemRoom) {
            searchItemRoom.remove();
          }
          item.setAttribute("id", "room-" + position);
          item.style.top = y - 16 + "px";
          item.style.left = x - 12 + "px";
          item.innerText = position;
          imageDiv.appendChild(item);
        }
      }
    }
  }
  invLerp(from, to, value) {
    return (value - from) / (to - from);
  }
  selectSpace(space): void {
    if (
      this.space.usersConnected != 0 &&
      this.space.usersConnected >= this.space.usersConnectedLimit
    ) {
      this.onWarning("", i18n.t("notifications.descriptions.spaceFull"));
      return;
    }
    const spaceId = parseInt(localStorage.getItem("space_default"));
    if (space.id !== spaceId || this.city) {
      localStorage.setItem("city", "OFF");
      localStorage.setItem("space_default", space.id.toString());
      window.location.reload();
    } else if (space.id == spaceId && !this.city) {
      window.location.reload();
      //this.$store.dispatch("SystemStore/setOpenChangeSpaceModalAction", false);
    }
  }
  addFavourite(isFavourite: boolean) {
    this.startLoader(this.$store);
    const tooltip = document.getElementsByClassName("vs-tooltip");
    if (tooltip)
      while (tooltip.length > 0) {
        tooltip[0].parentNode.removeChild(tooltip[0]);
      }
    this.$store.dispatch("SpaceStore/addToFavouriteAction", {
      spaceId: this.space.id,
      data: { isFavourite: !isFavourite },
      callback: (response) => {
        this.space.isFavourite = response.isFavourite;
        this.stopLoader(this.$store);
      },
      callbackError: (error) => {
        this.stopLoader(this.$store);
      },
    });
  }
}
